import { addDays } from 'date-fns';
import * as types from './types';
import { SavingsPlanRuleType } from './types';
export const fakeAccount = __DEV__
    ? {
        status: 'ACTIVE',
        kycVerification: {
            type: types.VerificationType.Identity,
            status: types.KYCStatus.Pending,
            requiredUserAction: 'UPLOAD_IDENTITY_DOCUMENT',
        },
    }
    : undefined;
export const emulateKYCNotStarted = __DEV__;
export const fakePots = [
    {
        id: '1',
        name: 'Christmas gifts',
        emoji: '🍎',
        balance: { amount: 91.37, currency: 'GBP' },
        goal: { amount: 200, currency: 'GBP', date: 'Thu Sep 22 2022 21:59:32 GMT+0545' },
    },
    {
        id: '2',
        name: 'Ibiza 2023',
        emoji: '🍊',
        balance: { amount: 91.37, currency: 'GBP' },
    },
];
export const useFakeData = false;
export const useFakePotsTransactions = __DEV__ && [
    {
        id: '1',
        type: 'deposit',
        title: 'Top up',
        formattedDate: '5:20 PM',
        formattedAmount: '$100',
    },
    {
        id: '2',
        type: 'withdraw',
        title: 'Withdraw',
        formattedDate: '5:05 PM',
        formattedAmount: '-$100',
    },
    {
        id: '3',
        title: 'Transfer',
        formattedDate: '5:00 PM',
        type: 'transferWithdraw',
        formattedAmount: '-$100',
    },
    {
        id: '4',
        title: 'Transfer',
        formattedDate: '4:45PM',
        type: 'transferDeposit',
        formattedAmount: '$100',
    },
];
/**
 * This will show "Your top-up is pending" in Pots,
 * and will also trigger periodic fetch for `/pending-top-ups` endpoint for 90 seconds.
 */
export const emulatePendingTopups = __DEV__ && true;
export const showFakeUpcomingAutosavePayments = __DEV__ && false;
export const fakeUpcomingAutosavePayments = [
    {
        id: '1',
        skipped: false,
        executionDate: addDays(new Date(), 1).toISOString(),
        amount: { value: 100, currency: 'GBP' },
        payoutTimestamp: addDays(new Date(), 2).toISOString(),
        initiationEta: addDays(new Date(), 1).toISOString(),
        destinations: [
            {
                potId: 'WALLET',
                percentage: 100,
                amount: {
                    value: 100,
                    currency: 'GBP',
                },
            },
        ],
    },
];
export const showFakeAutosaveActivities = __DEV__ && false;
export const fakeAutosaveActivities = [
    {
        id: '2',
        timestamp: '2024-02-13T00:00:00.000Z',
        amount: { value: 100, currency: 'GBP' },
        type: 'AUTO_SAVE',
        title: 'Autosave',
        status: 'PENDING',
        completedEta: '2024-02-21T00:00:00.000Z',
        paymentCollectionDate: '2024-02-14T00:00:00.000Z',
        initiatedAt: '2024-02-13T00:00:00.000Z',
        savingsPlanInfo: {
            payoutTimestamp: '2024-02-21T00:00:00.000Z',
            destinations: [
                {
                    potId: 'WALLET',
                    percentage: 90,
                    amount: {
                        value: 90,
                        currency: 'GBP',
                    },
                },
                {
                    potId: '3',
                    percentage: 10,
                    amount: {
                        value: 10,
                        currency: 'GBP',
                    },
                },
            ],
            rules: [
                {
                    type: SavingsPlanRuleType.AUTOMATED,
                    amount: {
                        value: 100,
                        currency: 'GBP',
                    },
                },
            ],
        },
    },
    {
        id: '4',
        timestamp: '2024-02-12T00:00:00.000Z',
        amount: { value: 100, currency: 'GBP' },
        type: 'AUTO_SAVE',
        title: 'Autosave',
        status: 'COMPLETED',
        paymentCollectionDate: '2024-02-13T00:00:00.000Z',
        initiatedAt: '2024-02-12T00:00:00.000Z',
        savingsPlanInfo: {
            payoutTimestamp: '2024-02-19T00:00:00.000Z',
            destinations: [
                {
                    potId: 'WALLET',
                    percentage: 90,
                    amount: {
                        value: 90,
                        currency: 'GBP',
                    },
                },
                {
                    potId: '5',
                    percentage: 10,
                    amount: {
                        value: 10,
                        currency: 'GBP',
                    },
                },
            ],
            rules: [
                {
                    type: SavingsPlanRuleType.AUTOMATED,
                    amount: {
                        value: 100,
                        currency: 'GBP',
                    },
                },
            ],
        },
    },
    {
        id: '6',
        timestamp: '2024-01-02T00:00:00.000Z',
        amount: { value: 100, currency: 'GBP' },
        type: 'AUTO_SAVE',
        title: 'Autosave',
        status: 'SKIPPED',
        paymentCollectionDate: '2024-01-03T00:00:00.000Z',
        initiatedAt: '2024-01-02T00:00:00.000Z',
        savingsPlanInfo: {
            payoutTimestamp: '2024-01-18T00:00:00.000Z',
            destinations: [
                {
                    potId: 'WALLET',
                    percentage: 90,
                    amount: {
                        value: 90,
                        currency: 'GBP',
                    },
                },
                {
                    potId: '7',
                    percentage: 10,
                    amount: {
                        value: 10,
                        currency: 'GBP',
                    },
                },
            ],
            rules: [
                {
                    type: SavingsPlanRuleType.AUTOMATED,
                    amount: {
                        value: 100,
                        currency: 'GBP',
                    },
                },
            ],
        },
    },
    {
        id: '8',
        timestamp: '2023-12-12T00:00:00.000Z',
        amount: { value: 200, currency: 'GBP' },
        type: 'AUTO_SAVE',
        title: 'Autosave',
        status: 'FAILED',
        paymentCollectionDate: '2023-12-13T00:00:00.000Z',
        initiatedAt: '2023-12-12T00:00:00.000Z',
        savingsPlanInfo: {
            payoutTimestamp: '2023-12-19T00:00:00.000Z',
            destinations: [
                {
                    potId: 'WALLET',
                    percentage: 90,
                    amount: {
                        value: 180,
                        currency: 'GBP',
                    },
                },
                {
                    potId: '9',
                    percentage: 10,
                    amount: {
                        value: 20,
                        currency: 'GBP',
                    },
                },
            ],
            rules: [
                {
                    type: SavingsPlanRuleType.AUTOMATED,
                    amount: {
                        value: 100,
                        currency: 'GBP',
                    },
                },
            ],
        },
    },
    {
        id: '10',
        timestamp: '2023-12-02T00:00:00.000Z',
        amount: { value: 200, currency: 'GBP' },
        type: 'AUTO_SAVE',
        title: 'Autosave',
        status: 'FAILED',
        paymentCollectionDate: '2023-12-03T00:00:00.000Z',
        initiatedAt: '2023-12-02T00:00:00.000Z',
        savingsPlanInfo: {
            payoutTimestamp: '2023-12-20T00:00:00.000Z',
            destinations: [
                {
                    potId: 'WALLET',
                    percentage: 90,
                    amount: {
                        value: 180,
                        currency: 'GBP',
                    },
                },
                {
                    potId: '11',
                    percentage: 10,
                    amount: {
                        value: 20,
                        currency: 'GBP',
                    },
                },
            ],
            rules: [
                {
                    type: SavingsPlanRuleType.AUTOMATED,
                    amount: {
                        value: 100,
                        currency: 'GBP',
                    },
                },
            ],
        },
    },
    {
        id: '12',
        timestamp: '2023-11-02T00:00:00.000Z',
        amount: { value: 50, currency: 'GBP' },
        type: 'AUTO_SAVE',
        title: 'Autosave',
        status: 'PENDING',
        completedEta: '2024-02-21T00:00:00.000Z',
        paymentCollectionDate: '2023-11-03T00:00:00.000Z',
        initiatedAt: '2023-11-02T00:00:00.000Z',
        savingsPlanInfo: {
            payoutTimestamp: '2023-11-21T00:00:00.000Z',
            destinations: [
                {
                    potId: 'WALLET',
                    percentage: 90,
                    amount: {
                        value: 45,
                        currency: 'GBP',
                    },
                },
                {
                    potId: '13',
                    percentage: 10,
                    amount: {
                        value: 5,
                        currency: 'GBP',
                    },
                },
            ],
            rules: [
                {
                    type: SavingsPlanRuleType.AUTOMATED,
                    amount: {
                        value: 100,
                        currency: 'GBP',
                    },
                },
            ],
        },
    },
    {
        id: '14',
        timestamp: '2023-10-02T00:00:00.000Z',
        amount: { value: 50, currency: 'GBP' },
        type: 'AUTO_SAVE',
        title: 'Autosave',
        status: 'COMPLETED',
        paymentCollectionDate: '2023-10-03T00:00:00.000Z',
        initiatedAt: '2023-10-02T00:00:00.000Z',
        savingsPlanInfo: {
            payoutTimestamp: '2023-10-22T00:00:00.000Z',
            destinations: [
                {
                    potId: 'WALLET',
                    percentage: 90,
                    amount: {
                        value: 45,
                        currency: 'GBP',
                    },
                },
                {
                    potId: '15',
                    percentage: 10,
                    amount: {
                        value: 5,
                        currency: 'GBP',
                    },
                },
            ],
            rules: [
                {
                    type: SavingsPlanRuleType.AUTOMATED,
                    amount: {
                        value: 100,
                        currency: 'GBP',
                    },
                },
            ],
        },
    },
];
export const basicPots = [
    {
        id: '1',
        name: 'Basic1',
        emoji: '1',
        balance: {
            value: 100,
            currency: 'USD',
        },
        type: 'BASIC',
        productId: 'santander',
    },
    {
        id: '2',
        name: 'Basic2',
        emoji: '1',
        balance: {
            value: 100,
            currency: 'USD',
        },
        type: 'BASIC',
        productId: 'santander',
    },
];
export const interestPots = [
    {
        id: '3',
        name: 'clearBank',
        emoji: '1',
        balance: {
            value: 100,
            currency: 'USD',
        },
        type: 'INTEREST',
        productId: 'clearBank',
    },
];
export const accumulatedInterestPots = [
    {
        id: '4',
        name: 'AccumulatedInterest',
        emoji: '1',
        balance: {
            value: 100,
            currency: 'USD',
        },
        type: 'ACCUMULATED_INTEREST',
        productId: 'clearBank',
    },
];
export const interestNoticePots = [
    {
        id: '5',
        name: 'InterestNotice',
        emoji: '1',
        balance: {
            value: 100,
            currency: 'USD',
        },
        productId: 'nepalBank',
        type: 'INTEREST_NOTICE',
    },
];
export const interestNoticePots2 = [
    {
        id: '5',
        name: 'InterestNotice',
        emoji: '1',
        balance: {
            value: 100,
            currency: 'USD',
        },
        productId: 'nepalBank2',
        type: 'INTEREST_NOTICE',
    },
];
export const accumulatedInterestNoticePots = [
    {
        id: '6',
        name: 'AccumulatedInterestNotice',
        emoji: '1',
        balance: {
            value: 100,
            currency: 'USD',
        },
        productId: 'nepalBank',
        type: 'ACCUMULATED_INTEREST_NOTICE',
    },
];
export const accumulatedInterestNoticePots2 = [
    {
        id: '6',
        name: 'AccumulatedInterestNotice',
        emoji: '1',
        balance: {
            value: 100,
            currency: 'USD',
        },
        productId: 'nepalBank2',
        type: 'ACCUMULATED_INTEREST_NOTICE',
    },
];
export const mockSpacePots = {
    '1': { ...basicPots },
    '2': { ...interestPots },
};
export const mockPots = [
    ...basicPots,
    ...interestPots,
    ...accumulatedInterestPots,
    ...interestNoticePots,
    ...accumulatedInterestNoticePots,
];
